module.exports = __webpack_public_path__ + "static/media/21.a1dae4e4.jpg";